import { Root } from '@radix-ui/react-context-menu';
import type React from 'react';
import { forwardRef } from 'react';

interface ContextMenuProps {
  children: React.ReactNode;
}

/**
 *  Reusable Root ContentMenu component.
 * ```tsx
 *  import ContextMenu from '~/components2/ContextMenu/ContextMenu'
 *
 *  <ContextMenu>
 *    <Trigger>{children}</Trigger>
 *    <Content>{...}</Content>
 *  </ContextMenu>
 * ```
 * @param {children} props.children - The contains all child elements (trigger/content/etc.)
 * @returns
 */
const ContextMenu = forwardRef(({ children }: ContextMenuProps, ref) => {
  return <Root>{children}</Root>;
});

ContextMenu.displayName = 'ContextMenu';
export default ContextMenu;
